import React, { useState, useEffect } from 'react';
import api from '../services/api';

function Videos() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [totalPages, setTotalPages] = useState(0);
  const [error, setError] = useState(null);

  const fetchVideos = async (pageNum = 1) => {
    setLoading(true);
    try {
      const response = await api.getVideos(pageNum, 20, null, search, statusFilter);
      setVideos(response.items || []);
      setTotalPages(response.total_pages || 0);
      setPage(pageNum);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVideos(1);
  }, [search, statusFilter]);

  const handleDelete = async (videoId) => {
    if (window.confirm('Are you sure?')) {
      try {
        await api.deleteVideo(videoId);
        fetchVideos(page);
      } catch (err) {
        setError(err.message);
      }
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'succeed': return '#4caf50';
      case 'failed': return '#f44336';
      case 'processing': return '#ff9800';
      case 'pending': return '#9e9e9e';
      default: return '#000';
    }
  };

  return (
    <div className="content-section">
      <h1>Videos</h1>

      {error && <div className="error-message">{error}</div>}

      <div className="toolbar">
        <input
          type="text"
          placeholder="Search videos..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />
        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          className="search-input"
        >
          <option value="">All Status</option>
          <option value="pending">Pending</option>
          <option value="processing">Processing</option>
          <option value="succeed">Succeed</option>
          <option value="failed">Failed</option>
        </select>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <table className="table">
            <thead>
              <tr>
                <th>Video ID</th>
                <th>User</th>
                <th>Status</th>
                <th>File Key</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {videos.map((video) => (
                <tr key={video.id}>
                  <td>{video.id}</td>
                  <td>{video.user_full_name || video.username}</td>
                  <td>
                    <span
                      className="status-badge"
                      style={{ backgroundColor: getStatusColor(video.status) }}
                    >
                      {video.status}
                    </span>
                  </td>
                  <td className="truncate">{video.file_key}</td>
                  <td>{new Date(video.created_at).toLocaleDateString()}</td>
                  <td>
                    <button
                      className="btn btn-small btn-danger"
                      onClick={() => handleDelete(video.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="pagination">
            <button
              onClick={() => fetchVideos(page - 1)}
              disabled={page <= 1}
              className="btn btn-small"
            >
              Previous
            </button>
            <span>Page {page} of {totalPages}</span>
            <button
              onClick={() => fetchVideos(page + 1)}
              disabled={page >= totalPages}
              className="btn btn-small"
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default Videos;
